"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopoverOrientering = exports.PopoverBase = void 0;
const React = __importStar(require("react"));
const ReactDOM = __importStar(require("react-dom"));
const classnames_1 = __importDefault(require("classnames"));
const nav_frontend_js_utils_1 = require("nav-frontend-js-utils");
const popover_base_1 = __importStar(require("./popover-base"));
const cls = (state, className) => (0, classnames_1.default)("popover--controlled", className, {
    "popover--hidden": !state.apen,
});
class Popover extends React.Component {
    constructor(props) {
        super(props);
        this.popoverRef = React.createRef();
        this.scrollParents = [];
        this.handleScroll = () => {
            if (!this.state.apen)
                return;
            this.updatePosition(this.props);
        };
        this.handleResize = () => {
            if (!this.state.apen)
                return;
            this.cachedMeasurements = this.popoverEl.getBoundingClientRect();
            this.updatePosition(this.props);
        };
        this.handleKeydown = (e) => {
            if (!this.state.apen)
                return;
            if (e.keyCode === nav_frontend_js_utils_1.keyCodes.esc)
                this.props.onRequestClose();
            if (e.keyCode === nav_frontend_js_utils_1.keyCodes.tab)
                this.checkFocus();
        };
        this.handleClick = (e) => {
            var _a;
            if (this.state.apen &&
                !((_a = ReactDOM.findDOMNode(this.props.ankerEl)) === null || _a === void 0 ? void 0 : _a.contains(e.target))) {
                this.props.onRequestClose();
            }
        };
        this.updatePosition = (props) => {
            const posisjon = this.calculatePosition(props);
            this.setState({ posisjon });
        };
        this.getPosition = () => {
            if (!this.state.apen || !this.state.posisjon)
                return;
            // eslint-disable-next-line consistent-return
            return {
                left: this.state.posisjon.left,
                top: this.state.posisjon.top,
                pilLeft: this.state.posisjon.pilLeft,
            };
        };
        this.checkFocus = () => {
            window.setTimeout(() => {
                const focusElement = document.activeElement;
                if (focusElement === this.popoverEl ||
                    focusElement === this.props.ankerEl ||
                    (this.popoverEl.contains && this.popoverEl.contains(focusElement))) {
                    return;
                }
                this.props.onRequestClose();
            }, 0); // tslint:disable-line:align
        };
        this.calculatePosition = (props) => {
            const popoverOffset = this.popoverEl.getBoundingClientRect();
            const ankerOffset = props.ankerEl.getBoundingClientRect();
            let avstandTilAnker = props.utenPil ? 0 : 12;
            if (typeof props.avstandTilAnker !== "undefined") {
                avstandTilAnker = props.avstandTilAnker;
            }
            let left;
            let top;
            switch (props.orientering) {
                case popover_base_1.PopoverOrientering.OverHoyre:
                    left = ankerOffset.left + ankerOffset.width - popoverOffset.width;
                    top = ankerOffset.top - avstandTilAnker - popoverOffset.height;
                    break;
                case popover_base_1.PopoverOrientering.OverVenstre:
                    left = ankerOffset.left;
                    top = ankerOffset.top - avstandTilAnker - popoverOffset.height;
                    break;
                case popover_base_1.PopoverOrientering.Venstre:
                    left = ankerOffset.left - popoverOffset.width - avstandTilAnker;
                    top =
                        ankerOffset.top + ankerOffset.height / 2 - popoverOffset.height / 2;
                    break;
                case popover_base_1.PopoverOrientering.Hoyre:
                    left = ankerOffset.left + ankerOffset.width + avstandTilAnker;
                    top =
                        ankerOffset.top + ankerOffset.height / 2 - popoverOffset.height / 2;
                    break;
                case popover_base_1.PopoverOrientering.UnderHoyre:
                    left = ankerOffset.left + ankerOffset.width - popoverOffset.width;
                    top = ankerOffset.top + ankerOffset.height + avstandTilAnker;
                    break;
                case popover_base_1.PopoverOrientering.UnderVenstre:
                    left = ankerOffset.left;
                    top = ankerOffset.top + ankerOffset.height + avstandTilAnker;
                    break;
                case popover_base_1.PopoverOrientering.Under:
                    left =
                        ankerOffset.left + ankerOffset.width / 2 - popoverOffset.width / 2;
                    top = ankerOffset.top + ankerOffset.height + avstandTilAnker;
                    break;
                default:
                    // PopoverOrientering.Over
                    left =
                        ankerOffset.left + ankerOffset.width / 2 - popoverOffset.width / 2;
                    top = ankerOffset.top - avstandTilAnker - popoverOffset.height;
                    break;
            }
            const viewPortDimensions = (0, nav_frontend_js_utils_1.getViewportDimensions)();
            left = Math.max(0, left);
            left = Math.min(Math.abs(left), Math.abs(viewPortDimensions.w - popoverOffset.width));
            const pilLeft = ankerOffset.left + ankerOffset.width / 2 - left - 1;
            return { left, top, pilLeft };
        };
        this.state = {
            apen: this.props.ankerEl !== undefined,
        };
    }
    componentDidMount() {
        window.addEventListener("click", this.handleClick);
        window.addEventListener("keydown", this.handleKeydown);
        this.popoverEl = this.popoverRef.current;
        this.scrollParents = (0, nav_frontend_js_utils_1.getScrollParents)(this.popoverEl);
        this.scrollParents.forEach((scrollParent) => scrollParent.addEventListener("scroll", this.handleScroll));
        this.props.ankerEl && this.updatePosition(this.props);
    }
    componentDidUpdate(prevProps, prevState) {
        if (!prevProps.ankerEl && this.props.ankerEl) {
            this.setState({ apen: true });
        }
        else if (prevProps.ankerEl && !this.props.ankerEl) {
            this.setState({ apen: false });
        }
        if (this.state.apen && !prevState.apen) {
            this.updatePosition(this.props);
            if (this.props.autoFokus)
                this.popoverEl.focus();
        }
    }
    // eslint-disable-next-line camelcase
    componentWillUnmount() {
        window.removeEventListener("click", this.handleClick);
        window.removeEventListener("keydown", this.handleKeydown);
        this.scrollParents.forEach((scrollParent) => scrollParent.removeEventListener("scroll", this.handleScroll));
    }
    render() {
        const _a = this.props, { children, ankerEl, onRequestClose, avstandTilAnker, autoFokus, className } = _a, rest = __rest(_a, ["children", "ankerEl", "onRequestClose", "avstandTilAnker", "autoFokus", "className"]);
        const position = this.getPosition();
        return (React.createElement(nav_frontend_js_utils_1.EventThrottler, { event: "resize", callback: this.handleResize, delay: 100 },
            React.createElement(popover_base_1.default, Object.assign({ className: cls(this.state, className), innerRef: this.popoverRef, posisjon: position, tabIndex: 0 }, rest), children)));
    }
}
Popover.defaultProps = {
    autoFokus: true,
};
exports.default = Popover;
var popover_base_2 = require("./popover-base");
Object.defineProperty(exports, "PopoverBase", { enumerable: true, get: function () { return __importDefault(popover_base_2).default; } });
var popover_base_3 = require("./popover-base");
Object.defineProperty(exports, "PopoverOrientering", { enumerable: true, get: function () { return popover_base_3.PopoverOrientering; } });
